import { NavLink } from "react-router-dom";
import { UserButton } from "@clerk/react";
import { Sheet, Users, ShieldCheck, BadgeCheck } from "lucide-react";
import { useApp } from "@/lib/app-context";

const linkCls = ({ isActive }) =>
  `inline-flex items-center gap-1.5 px-3 py-2 rounded-lg text-sm font-semibold transition-colors ${
    isActive ? "bg-[var(--ink)] text-white" : "text-slate-600 hover:bg-slate-100"
  }`;

export default function Header() {
  const { me } = useApp();
  return (
    <header className="sticky top-0 z-40 bg-white/90 backdrop-blur-xl border-b border-slate-200 print:hidden">
      <div className="max-w-[1800px] mx-auto px-3 sm:px-6 lg:px-8 h-16 flex items-center gap-3">
        <div className="font-heading text-lg font-extrabold text-[var(--ink)] mr-1 sm:mr-2 whitespace-nowrap" data-testid="app-logo">
          S<span className="hidden sm:inline">alary</span><span className="text-teal-600">B<span className="hidden sm:inline">ook</span></span>
        </div>
        <nav className="flex items-center gap-1 min-w-0">
          <NavLink to="/" end className={linkCls} data-testid="nav-sheet"><Sheet size={16} /><span className="hidden sm:inline">Monthly sheet</span></NavLink>
          <NavLink to="/staff" className={linkCls} data-testid="nav-staff"><Users size={16} /><span className="hidden sm:inline">Staff</span></NavLink>
          <NavLink to="/settlements" className={linkCls} data-testid="nav-settlements"><BadgeCheck size={16} /><span className="hidden sm:inline">Settlements</span></NavLink>
          {me.role === "admin" && (
            <NavLink to="/users" className={linkCls} data-testid="nav-users"><ShieldCheck size={16} /><span className="hidden sm:inline">Logins</span></NavLink>
          )}
        </nav>
        <div className="ml-auto flex items-center gap-2 shrink-0">
          {me.role === "staff" && <span className="text-[11px] font-bold px-2 py-1 rounded-full bg-slate-100 text-slate-600 whitespace-nowrap" data-testid="view-only-badge">View only</span>}
          <UserButton />
        </div>
      </div>
    </header>
  );
}
